<div id="neighborhood-filters">
  <div class="row">
    <p class="title">Bairros</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <lib-button-tertiary (click)="showModal=true">Adicionar</lib-button-tertiary>
</div>

<div class="neighborhoods modal" *ngIf="showModal==true">
  <div class="bg" (click)="showModal=false"></div>
  <div class="content">
    <div class="row">
      <p class="title">Filtro de bairros e regiões</p>
      <a class="close" (click)="showModal=false">&times;</a>
    </div>
    <div class="row">
      <div class="full">
        <app-input class="one-third" id="estado" label="Estado" placeholder="">
        </app-input>
        <app-input class="one-third" id="cidade" label="Cidade" placeholder="">
        </app-input>
      </div>
    </div>
    <div class="row scrollable">
      <div>
        <label>Centro</label>
        <lib-input-checkbox id="mock-1" class="item-action" label=""></lib-input-checkbox>
        <lib-input-checkbox id="mock-2" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-3" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-4" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-5" class="item-action" label="Mock"></lib-input-checkbox>
      </div>
      <div>
        <label>Leste</label>
        <lib-input-checkbox id="mock-6" class="item-action" label=""></lib-input-checkbox>
        <lib-input-checkbox id="mock-7" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-8" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-9" class="item-action" label="Mock"></lib-input-checkbox>
      </div>
      <div>
        <label>Oeste</label>
        <lib-input-checkbox id="mock-10" class="item-action" label=""></lib-input-checkbox>
        <lib-input-checkbox id="mock-11" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-12" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-13" class="item-action" label="Mock"></lib-input-checkbox>
      </div>
      <div>
        <label>Norte</label>
        <lib-input-checkbox id="mock-14" class="item-action" label=""></lib-input-checkbox>
        <lib-input-checkbox id="mock-15" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-16" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-17" class="item-action" label="Mock"></lib-input-checkbox>
      </div>
      <div>
        <label>Sul</label>
        <lib-input-checkbox id="mock-18" class="item-action" label=""></lib-input-checkbox>
        <lib-input-checkbox id="mock-19" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-20" class="item-action" label="Mock"></lib-input-checkbox>
        <lib-input-checkbox id="mock-21" class="item-action" label="Mock"></lib-input-checkbox>
      </div>

    </div>

    <div class="row buttons">
      <lib-button-tertiary (click)="showModal=false">Cancelar</lib-button-tertiary>
      <lib-button-primary>Adicionar</lib-button-primary>
    </div>
  </div>
</div>





















